/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  class VerticalAccordion extends HTMLElement {
    constructor() {
      super();
      this.expandBtn = this.querySelectorAll('.js-expand-btn');
      this.wrapper = this.querySelector('.js-wrapper');
      this.btnNext = this.querySelector('.js-next');
      this.btnPrev = this.querySelector('.js-prev');
      this.items = this.querySelectorAll('.js-va-item');
      this.lastExpanded = this.items[0];
      this.expandBtn.forEach(btn => btn.addEventListener('click', this.expandItem.bind(this, btn)));
      this.btnNext.addEventListener('click', this.next.bind(this));
      this.btnPrev.addEventListener('click', this.prev.bind(this));
    }
    connectedCallback() {
      this.offset = this.querySelector('.js-va-item:not(.is-expanded)').clientWidth;
      this.paddingLeft = this.querySelector('.js-va-item').offsetLeft;
    }
    next(event) {
      event.preventDefault();
      const current = this.querySelector('.js-va-item.is-expanded');
      const next = this.lastExpanded.nextElementSibling;
      if (next) {
        next.querySelector('.js-expand-btn').click();
      }

    }
    prev(event) {
      event.preventDefault();
      const prev = this.lastExpanded.previousElementSibling;
      if (prev) {
        prev.querySelector('.js-expand-btn').click();
      }

    }
    expandItem(btn) {
      console.log('expand');
      console.log(btn);
      const item = btn.closest('.js-va-item');
      const isExpanded = item.classList.contains('is-expanded') || false;
      this.items.forEach(item => {
        item.classList.remove('is-expanded');
        const currentVideo = item.querySelector('.video-embed video');
        if (currentVideo) {
            currentVideo.pause(); 
        }
    });
    
      if (!isExpanded) {
        item.classList.add('is-expanded');
        var currentVideo = item.querySelector('.video-embed video');
        currentVideo.play(); 
        this.lastExpanded = item;
      }
      setTimeout(() => {
        if (window.innerWidth < 1025) {
          const y = window.scrollY || window.pageYOffset;
          console.log(item.getBoundingClientRect());
          window.scrollTo({
            top: item.getBoundingClientRect().top + y - 100,
            behavior: 'smooth'
          });
        }
        else {
          this.wrapper.scrollTo({
            left: item.offsetLeft - this.paddingLeft,
            behavior: 'smooth'
          });
        }
      }, 250)
    }
  }
  customElements.define('vertical-accordion', VerticalAccordion);

  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.accordion = this;
      this.accordionBtn = this.querySelector('.js-accordion-button');
      this.accordionContent = this.querySelector('.js-accordion-content');
      this.teleport = this.closest('teleport-component');
      this.headerHover = this.closest('[data-hover-disclosure-toggle]');

      this.accordionBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.accordion.classList.contains('is-open')) {
          this.close();
        }
        else {
          this.open();
        }
        this.headerHover?.dispatchEvent(new MouseEvent('mouseenter'));
      })
    }
    close() {
      this.accordionContent.style.height = null;
      this.accordion.classList.remove('is-open');
      this.accordionContent.classList.remove('is-open');
      this.teleport?.clear();
    }
    open() {
      this.closest('.js-accordions-container')?.querySelectorAll('accordion-component')?.forEach(accordion => accordion.close());
      this.accordionContent.style.height = this.accordionContent.scrollHeight + 'px';
      this.accordionContent.classList.add('is-open');
      this.accordion.classList.add('is-open');
      this.teleport?.port(this.querySelector('.js-teleport-content').cloneNode(true));
    }
  }
  class TeleportComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.id = this.dataset.teleportId;
      this.place = document.querySelector(`[data-teleport-place=${this.id}]`);
      if (this.querySelector('[data-port-init]')) {
        this.port(this.querySelector('[data-port-init]').cloneNode(true));
      }
    }
    port(content) {
      this.place.appendChild(content);
    }
    clear() {
      this.place.innerHTML = "";
    }
  }
  class TabComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.tabOpener = this.querySelectorAll('.js-tab-opener');
      this.tabContent = this.querySelectorAll('.js-tab-content');
      this.scrollParent = this.closest('.drawer') || window;
      this.attachEvents();
    }
    attachEvents() {
      this.tabOpener.forEach(opener => {
        opener.addEventListener('click', (e) => {
          e.preventDefault();
          const id = opener.dataset.tabId;
          this.toggle(id)
        })
      })
    }
    toggle(id) {
      this.querySelectorAll(`[data-tab-id]`).forEach(tab => {
        tab.classList.remove('is-visible');
      });
      this.querySelectorAll(`[data-tab-id=${id}]`).forEach(tab => {
        tab.classList.add('is-visible');
      });
      setTimeout(() => {
        this.scrollParent.scrollTo({
          top: this.offsetTop,
          behavior: 'smooth'
        });
      }, 0);
    }

  }

  class VideoEmbed extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.playBtn = this.querySelector('.js-play-btn');
      this.isPlaying = false;
      this.playBtn?.addEventListener('click', () => {
        this.video.play();
      })
      this.video.addEventListener('play', () => {
        if (this.playBtn) this.playBtn.style.display = "none";
        this.isPlaying = true;
      })
      this.video.addEventListener('pause', () => {
        if (this.playBtn) this.playBtn.style.display = "block";
        this.isPlaying = false;
      })
      this.video.addEventListener('click', () => {
        if (this.isPlaying) {
          this.video.pause();
        }
        else {
          this.video.play();
        }
      })
    }
    
  }
  
  
  document.addEventListener('DOMContentLoaded', (event) => {
    customElements.define('accordion-component', AccordionComponent);
    customElements.define('teleport-component', TeleportComponent);
    customElements.define('tab-component', TabComponent);
    customElements.define('video-embed', VideoEmbed);
  })
  




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// Add english class to HE market if page has EN content
document.addEventListener('DOMContentLoaded', function() {
  // Function to check if a string contains Hebrew characters

  function isHebrew(text) {
    const hebrewRegex = /[\u0590-\u05FF]/;
    return hebrewRegex.test(text);
  }

  // Function to iterate through all <div>, <span>, <p> elements and assign the correct class
  function assignLanguageClasses() {
    const elements = document.querySelectorAll('div, span, p, h1, h2, h3, h4, h5, a'); // Select all relevant elements

    elements.forEach(element => {
      const textContent = element.textContent || element.innerText; // Get the text content of the element
      if (!isHebrew(textContent)) {
        // Add EN class
        element.classList.add('langen');
      }
    });
  }
  
  // Run the function after the document is fully loaded
  if (document.documentElement.lang === 'he') {
    assignLanguageClasses();
  }
});

document.addEventListener("DOMContentLoaded", function () {  
    const video = document.getElementById("video_mKyXUd-video-background");  
    if (video) {  
        video.preload = "auto";  
        video.load(); // Force the browser to start loading the video  
    }  
});  


if (typeof jQuery != 'undefined') {  

    $(document).ready(function(){

      try{
        $(".ingredients-slider").slick({
        slidesToShow: 4,
        infinite:true,
        slidesToScroll: 4,
        arrows:true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          
        ],
      });
    } catch(e){console.log("ingredients-slider slick")}
    
    function c(){const d=$(".featured-video-section.scroll_play_video"),e=d.length&&d.is(":visible")&&d.offset().top+d.outerHeight()>$(window).scrollTop()&&d.offset().top<$(window).scrollTop()+$(window).height(),f=$(".featured-video-section.scroll_play_video video")[0];$(".featured-video-section.scroll_play_video video").length!=0&&(e?(console.log("Section is Visible"),f.play()):(console.log("Section is Not Visible"),f.pause()))}$(window).on("scroll resize",function(){c()}),c()

  });
} 







document.addEventListener('DOMContentLoaded', () => {
  const orderDates = document.querySelectorAll('[lang=he] .order-date');

  orderDates.forEach((element) => {
    const date = new Date(element.getAttribute('data-date'));
    const options = { year: 'numeric', month: 'long', day: 'numeric' }; // Adjust for Hebrew conventions
    const formattedDate = date.toLocaleDateString('he-IL', options);

    element.textContent = formattedDate;
  });
});

document.addEventListener("click", function (event) {
  if (event.target.closest(".filter_grid_option .collection-toolbar__button")) {
    if (!event.target.classList.contains("is-active")) {
      document.querySelectorAll(".filter_grid_option .collection-toolbar__button").forEach(function (button) {
        button.classList.remove("is-active");
      });
      event.target.classList.add("is-active");
      var grid = event.target.value;
      var collectionProducts = document.querySelector(".collection__inner .collection__products");
      if (grid === "singal_grid") {
        collectionProducts.classList.remove("double_grid");
        collectionProducts.classList.add("singal_grid");
      } else {
        collectionProducts.classList.remove("singal_grid");
        collectionProducts.classList.add("double_grid");
      }
    }
  }
});

/* Swym Wishlist Add to Cart Drawer */
function onSwymLoadCallback(swat) {
    swat.evtLayer.addEventListener(swat.JSEvents.UIAddedToCart, function() {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
    });
    /* For Move All to Cart buttons - required if SFL/Move All to Cart button is enabled */
    swat.evtLayer.addEventListener(swat.JSEvents.UIAddedAllToCart, function() {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
    });
}
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

document.addEventListener('DOMContentLoaded', function() {
  let currentVariant = document.querySelector('[data-product-select]');
  let productData = document.querySelector('[data-product-json]');
  let priceWrapper = document.querySelector('[data-product-price] .glc-money');
  if ( ! priceWrapper || ! productData || ! currentVariant ) return;
  
  let currencySymbol = priceWrapper.innerHTML.split(' ')[0];
  productData = JSON.parse(productData.innerHTML);
  console.log(productData.id);
  
  currentVariant.addEventListener('change', function(e) {
    let id = parseInt(this.value, 10);
    let data = productData.variants.filter((elem) => elem.id === id );
    let newPrice = parseFloat(data[0].price) / 100;
    priceWrapper.innerHTML = `${currencySymbol} ${newPrice}`;
  });
}); 

document.addEventListener('DOMContentLoaded', function() {  
  // Select the elements  
  const slideLogo = document.querySelector('.slide__logo');  
  const elementToHide = document.querySelector('.logo__image-link');   

  // Initially hide the element  
  elementToHide.classList.remove('show');    

  // Function to check the scroll position  
  function checkScroll() {  
      const scrollY = window.scrollY || window.pageYOffset;  
      const isMobile = window.matchMedia("(max-width: 768px)").matches; // Adjust the breakpoint as needed  
      const threshold = isMobile ? 240 : 440; // Set threshold based on device type  

      // Check if the body has the class 'template-index'  
      if (document.body.classList.contains('template-index') && slideLogo ) {  
          // Check if the slide__logo has an image and if the scroll position meets the threshold  
          if (slideLogo.querySelector('img') && scrollY >= threshold) {  
              elementToHide.classList.add('show');  // Show the element  
          } else {  
              elementToHide.classList.remove('show');  // Hide the element  
          }  
      }  
  }  

  // Add scroll event listener  
  window.addEventListener('scroll', checkScroll);  
});  

let locationUrl = window.location.href;
console.log(locationUrl);

// Check if the URL contains the 'created=true' parameter
if (locationUrl.includes('created=true')) {
  if (document.querySelector(".account_created_success")){
      document.querySelector(".account_created_success")?.classList.add("show");
      // Hide the success message after 5 seconds
      setTimeout(function () {
        document.querySelector(".account_created_success")?.classList.remove("show");
      }, 10000);
  }

} else {
  // Ensure the message remains hidden when the parameter is not present
  document.querySelector(".account_created_success")?.classList.remove("show");
}



  const announcementBar = document.querySelector('[data-announcement-bar]');
  const shippingMessageBar = document.querySelector(".cart__text_for_int_users");
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  // Fetch the user's location using a geolocation API

(function(){
  document.addEventListener('DOMContentLoaded', function() {

    document.addEventListener('click', async function(e) {
      if ( e.target.matches('[data-buy-now-id]') || e.target.closest('[data-buy-now-id]')) {
        // alert('ahahah');
        let $this = e.target;
        $this.classList.add('is-loading');
        let productId = $this.dataset.buyNowId;
        if ( ! productId ) {
          window.location.href = $this.dataset.productUrl;
        }
        const LIMITED_VARIANT_ID = 43595606491235; // Замените на реальный ID вашего варианта
        const MAX_QUANTITY = 1;
        if ( parseInt(productId, 10) === parseInt(LIMITED_VARIANT_ID, 10) ) {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          if (!cart || !cart.items) return;

          // 2. Ищем наш товар в корзине
          const targetItem = cart.items.find(item => item.variant_id === LIMITED_VARIANT_ID);

          // 3. Проверяем, превышено ли количество
          if (targetItem && targetItem.quantity > MAX_QUANTITY) {
            try {
              // 4. Отправляем запрос на изменение количества до 1
              const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: targetItem.key,
                  quantity: MAX_QUANTITY
                })
              });

              if (response.ok) {
                // 5. Показываем уведомление
                alert(`Sorry, product "${targetItem.product_title}" can be added only 1 to cart. Over items was removed.`);
                
                // 6. Перезагружаем страницу или обновляем секцию корзины, чтобы изменения отобразились
                // В большинстве тем Dawn достаточно вызвать событие обновления:
                // window.location.reload(); 
                document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
              }
            } catch (error) {
              console.error("Error while cart update:", error);
            }
          } else if ( targetItem && targetItem.quantity === MAX_QUANTITY ) {
            alert(`Sorry, product "${targetItem.product_title}" can be added only 1 to cart. Over items was removed.`);
            return false;
          }
          
        }
        let formData = {'items': [{'id': productId,'quantity': 1}]};
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          console.log(response);
          if ( response.status == 200 ) {
            $this.classList.remove('is-loading');
            window.location.href = '/checkout';
          } else {
            alert('Something goes wrong, write to support.');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    });
    
     document.addEventListener("theme:cart:added", async (event) => {
      // 1. Настройки: ID варианта товара, который нужно ограничить
      const LIMITED_VARIANT_ID = 43595606491235; // Замените на реальный ID вашего варианта
      const MAX_QUANTITY = 1;

      // Получаем данные корзины из события или через API
      // const cart = event.detail.cart;
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart || !cart.items) return;

      // 2. Ищем наш товар в корзине
      const targetItem = cart.items.find(item => item.variant_id === LIMITED_VARIANT_ID);

      // 3. Проверяем, превышено ли количество
      if (targetItem && targetItem.quantity > MAX_QUANTITY) {
        
        try {
          // 4. Отправляем запрос на изменение количества до 1
          const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: targetItem.key,
              quantity: MAX_QUANTITY
            })
          });

          if (response.ok) {
            // 5. Показываем уведомление
            alert(`Sorry, product "${targetItem.product_title}" can be added only 1 to cart. Over items was removed.`);
            
            // 6. Перезагружаем страницу или обновляем секцию корзины, чтобы изменения отобразились
            // В большинстве тем Dawn достаточно вызвать событие обновления:
            // window.location.reload(); 
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          }
        } catch (error) {
          console.error("Error while cart update:", error);
        }
      }
    });

     
      
  }, false);
})();

(function () {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        document.addEventListener('change', function (e) {
          // 1. Логика чекбокса
          if (e.target && e.target.id === 'gift-card-checkbox') {
            const isChecked = e.target.checked;
            const previewContainer = document.getElementById('gift-card-preview-container');

            if (previewContainer) {
              previewContainer.style.display = isChecked ? 'block' : 'none';
            }

            // Сохраняем состояние в корзину Shopify через AJAX,
            // чтобы при обновлении страницы галочка не слетела
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  'Include Gift Card': isChecked ? 'Yes' : 'No',
                },
              }),
            });
          }
        });

        document.addEventListener('click', function (e) {
          const modal = document.getElementById('gift-card-modal');

          // 2. Открытие модалки (клик по превью)
          if (e.target && e.target.id === 'gift-card-thumbnail') {
            if (modal) modal.style.display = 'flex';
          }

          // 3. Закрытие модалки (клик по крестику или фону)
          if (e.target && (e.target.id === 'close-modal' || e.target === modal)) {
            if (modal) modal.style.display = 'none';
          }
        });
      },
      false
    );
  })();